import { toDateInputValue } from "./date";

export const normalizeNullableCurrencyInput = (value) => {
  if (value === "") {
    return "";
  }

  return value.replace(/[^\d.]/g, "");
};

export const normalizeNullableEmailInput = (value) => value ?? "";

export const buildSettlementAmountValues = (caseDetail) => ({
  actualTotalSettlementAmount: caseDetail?.actualTotalSettlementAmount ?? "",
  insuranceSettlementDate: toDateInputValue(caseDetail?.insuranceSettlementDate),
  settlementFinalizedOn: toDateInputValue(caseDetail?.settlementFinalizedOn),
});

export const buildSettlementAmountPayload = (formValues) => ({
  actualTotalSettlementAmount:
    formValues.actualTotalSettlementAmount === "" ? null : formValues.actualTotalSettlementAmount,
  insuranceSettlementDate: formValues.insuranceSettlementDate || null,
  settlementFinalizedOn: formValues.settlementFinalizedOn || null,
});

export const isSettlementAmountDirty = (formValues, initialValues) =>
  formValues.actualTotalSettlementAmount !== initialValues.actualTotalSettlementAmount ||
  formValues.insuranceSettlementDate !== initialValues.insuranceSettlementDate ||
  formValues.settlementFinalizedOn !== initialValues.settlementFinalizedOn;

export const buildReductionsValues = (caseDetail) => ({
  reductionReceivedFrom:
    caseDetail?.reductionReceivedFrom ?? caseDetail?.reduction_received_from ?? "",
  reductionReceivedDate: toDateInputValue(
    caseDetail?.reductionReceivedDate ?? caseDetail?.reduction_received_date
  ),
  reductionApprovedDate: toDateInputValue(
    caseDetail?.reductionApprovedDate ?? caseDetail?.reduction_approved_date
  ),
  reductionCompletedDate: toDateInputValue(
    caseDetail?.reductionCompletedDate ?? caseDetail?.reduction_completed_date
  ),
});

export const buildReductionsPayload = (formValues) => ({
  reduction_received_from: formValues.reductionReceivedFrom || null,
  reduction_received_date: formValues.reductionReceivedDate || null,
  reduction_approved_date: formValues.reductionApprovedDate || null,
  reduction_completed_date: formValues.reductionCompletedDate || null,
});

export const isReductionsDirty = (formValues, initialValues) =>
  formValues.reductionReceivedFrom !== initialValues.reductionReceivedFrom ||
  formValues.reductionReceivedDate !== initialValues.reductionReceivedDate ||
  formValues.reductionApprovedDate !== initialValues.reductionApprovedDate ||
  formValues.reductionCompletedDate !== initialValues.reductionCompletedDate;
